import ClickableDiv from './ClickableDiv.js';
import './ClickableDiv.scss';

export default ClickableDiv;
